import React, { useContext, useEffect, useState } from 'react';
import FittingRecommendations from '../FittingRecommendations/FittingRecommendations';
import Styles from './InsightDetails.module.scss';
import Avatar from '../../assets/images/icons/avatar-default.jpg';
import { insightsContext } from '../../context/insightsContext';

const InsightDetails = (props) => {
  const insights = useContext(insightsContext);
  const { state } = insights;
  const { data, currentInsight } = state;
  const { authorInfo } = props;
  const [imgSrc, setImgSrc] = useState(Avatar);
  useEffect(() => {
    setImgSrc(authorInfo?.profileImage ?? Avatar);
  }, [authorInfo]);

  const scrollToAuthor = () => {
    const authorContainer = document.getElementById('authorInfoContainer');
    authorContainer.scrollIntoView({ behavior: 'smooth' });
  };

  const getJobTitleText = () => {
    let a = authorInfo?.jobTitle;
    if (a !== '' && authorInfo?.job !== '') {
      a += ', ';
    }
    a += authorInfo?.job || '';
    return a;
  };

  return (
    <div>
      {data
        && (
          <div className={Styles.insightContainer}>
            <>
              <div className={Styles.insightHeader}>
                {data[currentInsight].longTitle}
              </div>
              {authorInfo && (
                <>
                  <div className={Styles.authorDetails}>
                    <div><img className={Styles.avatar} src={imgSrc} alt='user-avatar' onError={() => setImgSrc(Avatar)} /></div>
                    <div>
                      <div>
                        Insight provided by
                        <a
                          tabIndex='0'
                          className={Styles.authorScrollLink}
                          onClick={() => scrollToAuthor()}
                        >
                          {authorInfo?.name}
                        </a>
                      </div>
                      <div className={Styles.jobTitle}>{getJobTitleText()}</div>
                    </div>
                  </div>
                </>
              )}
            </>
            <div className={Styles.insightDescription}>
              {data[currentInsight].insightDescription}
            </div>
            {data[currentInsight].fittingRecommendations && (
              <FittingRecommendations
                recommendations={data[currentInsight].fittingRecommendations}
              />
            )}
          </div>
        )
      }
    </div>
  );
};

export default InsightDetails;
